import React from "react";
import moment from "moment-jalaali";
import {
  ObjectConfirmCssClasses,
  ObjectConfirmRoomReservationTitles,
  ObjectReserveStatusTitles
} from "../../ObjectsUIHelpers";
import { FormattedMessage, FormattedDate, FormattedTime } from "react-intl";

export const ConfirmColumnFormatter = (cellContent, row) => (
  <span

    className={`label label-lg label-light-${ObjectConfirmCssClasses[(+row.isConfirm)]
      } label-inline pt-3 pb-3`}
  >
    <FormattedMessage id={ObjectConfirmRoomReservationTitles[(+row.isConfirm)]} />
  </span>
);


export const ConfirmRoomReservationColumnFormatter = (cellContent, row) => (

  <>

    {row.isCanceled &&
      < span
        className={`label label-lg label-light-warning label-inline pt-3 pb-3`}
      >
        <FormattedMessage id="MODULES.GENERAL.CANCELED" />
        {row.canceledAt && (
          <>
            {" - "}
            <FormattedTime value={row.canceledAt} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />
          </>
        )}
      </span>
    }

    {!row.isCanceled && row.isPayed &&
      < span
        className={`label label-lg label-light-success label-inline pt-3 pb-3`}
      >
        <FormattedMessage id="MODULES.GENERAL.PAID" />
        {row.payedAt && (
          <>
            {" - "}
            <FormattedTime value={row.payedAt} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />
          </>
        )}
      </span>
    }
    
    {!row.isCanceled && !row.isPayed && row.isExpired &&
      < span
        className={`label label-lg label-light-danger label-inline pt-3 pb-3`}
      >
        <FormattedMessage id="MODULES.GENERAL.EXPIRED" />
        {/* {" - "}
        <FormattedMessage id={ObjectConfirmRoomReservationTitles[(+row.isConfirm)]} /> */}
      </span>

    }

    {!row.isCanceled && !row.isPayed && !row.isExpired && row.acceptOperatorId && row.isConfirm &&
      <span
        //   className={`label label-lg label-light-${ObjectConfirmCssClasses[(+row.isConfirm)]
        //     } label-inline`}
        // >
        className={`label label-lg label-light-info label-inline pt-3 pb-3`} >
        <FormattedMessage id="MODULES.GENERAL.NEEDPAY" />
        {row.confirmAt && (
          <>
            {" - "}
            <FormattedTime value={row.confirmAt} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />
          </>
        )}
      </span>
    }

    {!row.isCanceled && !row.isPayed && !row.isExpired && !row.acceptOperatorId &&
      < span
        className={`label label-lg label-light-info label-inline pt-3 pb-3`}
      >
        {!row.isManual && row.reservationTimeSetting
          && (row.expiredAt == row.reservationTimeSetting.payExpireDate || row.expiredAt == row.reservationTimeSetting.replacePayExpireDate)
          && <FormattedMessage id="MODULES.GENERAL.NEEDPAY" />}

        {!row.isManual && row.reservationTimeSetting
          && (row.expiredAt == row.reservationTimeSetting.confirmExpireDate || row.expiredAt == row.reservationTimeSetting.replaceConfirmExpireDate)
          && <FormattedMessage id="MODULES.ROOM.RESERVATION.CONFIRMED" />}

        {row.isManual && <FormattedMessage id="MODULES.GENERAL.NEEDPAY" />}
        {row.createAt && (
          <>
            {" - "}
            <FormattedTime value={row.createAt} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />
          </>
        )}
      </span>
    }

    {row.isReplaced &&
      <span
        className={`label label-lg label-light-info label-inline pt-3 pb-3`}
      >
        <FormattedMessage id="MODULES.GENERAL.REPLACED" />
      </span>
    }

  </>
);

export const PayedSportReservationColumnFormatter = (cellContent, row) => (

  <>

    {row.isCanceled &&
      < span
        className={`label label-lg label-light-warning label-inline pt-3 pb-3`}
      >
        <FormattedMessage id="MODULES.GENERAL.CANCELED" />
        {row.canceledAt && (
          <>
            {" - "}
            <FormattedTime value={row.canceledAt} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />
          </>
        )}
      </span>
    }

    {!row.isCanceled && row.isPayed &&
      < span
        className={`label label-lg label-light-success label-inline pt-3 pb-3`}
      >
        <FormattedMessage id="MODULES.GENERAL.PAID" />
        {row.payedAt && (
          <>
            {" - "}
            <FormattedTime value={row.payedAt} day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" />
          </>
        )}
      </span>
    }

    {!row.isCanceled && row.calendarDate && moment().isAfter(row.calendarDate) &&
      < span
        className={`label label-lg label-light-danger label-inline pt-3 pb-3`}
      >
        <FormattedMessage id="MODULES.GENERAL.EXPIRED" />
      </span>

    }
  </>
);